module.exports = __webpack_public_path__ + "media/atrophic gastritis.e258b718.wav";